module.exports = __webpack_public_path__ + "img/benefit-work.a70c379c.svg";